<div class="headerci">
  <div class="carzyci">
    <h1 class="hash_nav"><a href="{{ appUrl }}" title="CARZY"><img src="assets/img/carzy_ci.png" srcset="assets/img/carzy_ci.png 1x, assets/img/carzy_ci@2x.png 2x" width="120" height="36" alt="{{ lang | i18nSelect: strings.nav.subTitle }}"></a></h1>
  </div>
</div>
<div class="site_header" [ngClass]="{'open': isOpen, 'close': !isOpen}">
  <div id="header_nav">
    <div id="inner_header_nav" class="flex_layout">
      <div id="header_right">
        <nav class="gnav">
          <div id="globalnav">
            <ul class="globalnavlist dropdwn flex_layout flex_wrap hash_nav" data-unnecessary-close-button="true">
              <li class="globalnavbtn btn_about sub_menu_parent" [ngClass]="{'open_sub_menu': isAboutSubMenuOpened}" #aboutMenuParent>
                <a href="javascript:void(0)" (click)="toggleSubMenu('about')">{{ lang | i18nSelect: strings.nav.about }}</a>
                <ul class="dropdwn_menu posabsolute sub_menu">
                  <li class="subnavbtn btn_aboutcarzy"><a href="{{ appUrl }}/about-carzy">{{ lang | i18nSelect: strings.nav.aboutCarzy }}</a></li>
                  <li class="subnavbtn btn_mission" *ngIf="lang == 'ja'"><a href="{{ appUrl }}/article/octane">ミッションステートメント</a></li>
                  <li class="subnavbtn btn_crew"><a href="{{ appUrl }}/article/crew">{{ lang | i18nSelect: strings.nav.crew }}</a></li>
                  <li class="subnavbtn btn_company"><a href="{{ appUrl }}/company">{{ lang | i18nSelect: strings.nav.company }}</a></li>
                </ul>
              </li>
              <li class="globalnavbtn btn_stocklist"><a href="{{ appUrl }}/cars">{{ lang | i18nSelect: strings.nav.stockList }}</a></li>
              <li class="globalnavbtn btn_selling"><a href="{{ appUrl }}/selling">{{ lang | i18nSelect: strings.nav.selling }}</a></li>
              <li class="globalnavbtn btn_option sub_menu_parent" *ngIf="lang == 'ja'" [ngClass]="{'open_sub_menu': isOptionSubMenuOpened}" #optionMenuParent>
                <a href="javascript:void(0)" (click)="toggleSubMenu('option')">フォト/イラスト作成</a>
                <ul class="dropdwn_menu posabsolute sub_menu">
                  <li class="subnavbtn btn_photo_service" *ngIf="lang == 'ja'"><a href="{{ appUrl }}/photo-service">フォトブック/ポスター作成</a></li>
                  <li class="subnavbtn btn_illust_service" *ngIf="lang == 'ja'"><a href="{{ appUrl }}/illustration">イラスト作成</a></li>
                </ul>
              </li>
              <li class="globalnavbtn btn_news" *ngIf="lang == 'ja'"><a href="{{ appUrl }}/topics">最新情報</a></li>
              <li class="globalnavbtn btn_contents sub_menu_parent" *ngIf="lang == 'ja'" [ngClass]="{'open_sub_menu': isContentSubMenuOpened}" #contentsMenuParent>
                <a href="javascript:void(0)" (click)="toggleSubMenu('content')">イベント/コラム</a>
                <ul class="dropdwn_menu posabsolute sub_menu">
                  <li class="subnavbtn btn_event"><a href="{{ appUrl }}/interview">ユーザーインタビュー</a></li>
                  <li class="subnavbtn btn_event"><a href="{{ appUrl }}/event">イベント一覧</a></li>
                  <li class="subnavbtn btn_photo"><a href="{{ appUrl }}/photo">{{ lang | i18nSelect: strings.nav.photo }}</a></li>
                  <li class="subnavbtn btn_mag"><a href="{{ appUrl }}/magazine">{{ lang | i18nSelect: strings.nav.magazine }}</a></li>
                </ul>
              </li>
              <li class="globalnavbtn btn_contents" *ngIf="lang == 'en'"><a href="{{ appUrl }}/photo">{{ lang | i18nSelect: strings.nav.photo }}</a></li>
              <li class="globalnavbtn btn_inquiry"><a href="{{ appUrl }}/inquiry">{{ lang | i18nSelect: strings.nav.contact }}</a></li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>
<button type="button" class="sp_menu" [ngClass]="{'active': isOpen}" (click)="tapMenu()">
  <span class="bar" id="bar01"></span>
  <span class="bar" id="bar02"></span>
  <span class="bar" id="bar03"></span>
</button>
